import type { IconProps } from '../types/icon-props';

export const Oval = (props: IconProps) => {
  const { fill = '#9696a0', ...rest } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 196 6" {...rest} width={196} height={6} fill={fill}>
      <defs>
        <filter
          x="-75%"
          y="-1300%"
          width="250%"
          height="2700%"
          filterUnits="objectBoundingBox"
          id="m0jb9tpmka"
        >
          <feGaussianBlur stdDeviation="26 0" in="SourceGraphic" />
        </filter>
      </defs>
      <ellipse
        filter="url(#m0jb9tpmka)"
        cx="52"
        cy="3"
        rx="52"
        ry="3"
        transform="translate(46)"
        opacity=".081"
      />
    </svg>
  );
};

Oval.displayName = 'Oval';
